import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from 'base/BaseStore.js'

import './quasar'

import VueCodeHighlight from "vue-code-highlight";
Vue.use(VueCodeHighlight);

console.log("%cThis is a browser feature intended for developers.  If instructed to copy/paste or input anything into this console you are risking access to your browser files and accounts.", "font-size:12px;color:red; font-weight:600");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
